/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Tags_ControlInputs */

const en_control_tags_control = /** @type {(inputs: Control_Tags_ControlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Control`)
};

const zh_control_tags_control = /** @type {(inputs: Control_Tags_ControlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`控制`)
};

/**
* | output |
* | --- |
* | "Control" |
*
* @param {Control_Tags_ControlInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_tags_control = /** @type {((inputs?: Control_Tags_ControlInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Tags_ControlInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_tags_control(inputs)
	return zh_control_tags_control(inputs)
});
export { control_tags_control as "control.tags.control" }